import { render, staticRenderFns } from "./arinvpayview.vue?vue&type=template&id=23c66770"
import script from "./arinvpayview.vue?vue&type=script&lang=js"
export * from "./arinvpayview.vue?vue&type=script&lang=js"
import style0 from "./arinvpayview.vue?vue&type=style&index=0&id=23c66770&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports